import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { MainBreadcrumbs } from './MainBreadcrumbs'
import { Events } from '@/main/components/Events/Events'
import { AppButton } from '@/main/components/AppButton/AppButton'
import { ListSnackbar } from '@/main/features/List/components/ListSnackbar/ListSnackbar'

export function MainLayout() {
  const { pathname } = useLocation()

  const indexIsActive = pathname === '/'

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [pathname])

  return (
    <>
      <AppButton isInactive />
      {!indexIsActive && <MainBreadcrumbs />}

      <article
        className={`twc-relative twc-overflow-hidden xl:twc-mb-20 twc-col-span-2 xl:twc-min-h-[50vh] twc-border-b xl:twc-border-b-0 dark:twc-border-slate-700 ${
          pathname === '/'
            ? 'twc-cart__index'
            : pathname.indexOf('form') > -1
            ? 'twc-cart__form'
            : 'twc-cart__project'
        }`}
      >
        <Outlet />
      </article>

      <Events />
      <ListSnackbar />
    </>
  )
}
